export enum Status {
    NotStarted = "Not Started",
    InProgress = "In progress",
    FInished = "Finished"
}